export enum PermissionCode {
  SUPER_ADMIN = 'SUPER_ADMIN',
  DASHBOARD_ACCESS = 'CAR_DASHBOARD_ACCESS',
  AGENCY_MANAGEMENT_ACCESS = 'CAR_AGENCY_MANAGEMENT_ACCESS',
  AGENCY_MANAGEMENT_VIEW = 'CAR_AGENCY_MANAGEMENT_VIEW',
  AGENCY_MANAGEMENT_TOGGLE_STATUS = 'CAR_AGENCY_MANAGEMENT_TOGGLE_STATUS',
  AGENCY_MANAGEMENT_EDIT_BAGDE = 'CAR_AGENCY_MANAGEMENT_EDIT_BAGDE',
  AGENCY_MANAGEMENT_CHANGE_PROFILE = 'CAR_AGENCY_MANAGEMENT_CHANGE_PROFILE',
  AGENCY_MANAGEMENT_BROWSE_ACCOUNT = 'CAR_AGENCY_MANAGEMENT_BROWSE_ACCOUNT',
  AGENCY_MANAGEMENT_EXPORT = 'CAR_AGENCY_MANAGEMENT_EXPORT',
  MANAGEMENT_ACCESS = 'CAR_MANAGEMENT_ACCESS',
  MANAGEMENT_VIEW = 'CAR_MANAGEMENT_VIEW',
  MANAGEMENT_DEACTIVE = 'CAR_MANAGEMENT_DEACTIVE',
  MANAGEMENT_CHANGE_RATING = 'CAR_MANAGEMENT_CHANGE_RATING',
  ROUTE_MANAGEMENT_ACCESS = 'CAR_ROUTE_MANAGEMENT_ACCESS',
  ROUTE_MANAGEMENT_VIEW = 'CAR_ROUTE_MANAGEMENT_VIEW',
  ROUTE_MANAGEMENT_TOGGLE_STATUS = 'CAR_ROUTE_MANAGEMENT_TOGGLE_STATUS',
  ROUTE_MANAGEMENT_DELETE = 'CAR_ROUTE_MANAGEMENT_DELETE',
  BOOKING_HELPDESK_ACCESS = 'CAR_BOOKING_HELPDESK_ACCESS',
  BOOKING_HELPDESK_VIEW = 'CAR_BOOKING_HELPDESK_VIEW',
  BOOKING_HELPDESK_VIEW_DETAIL = 'CAR_BOOKING_HELPDESK_VIEW_DETAIL',
  BOOKING_HELPDESK_CONFIRM = 'CAR_BOOKING_HELPDESK_CONFIRM',
  BOOKING_HELPDESK_CANCEL = 'CAR_BOOKING_HELPDESK_CANCEL',
  BOOKING_HELPDESK_EXPORT = 'CAR_BOOKING_HELPDESK_EXPORT',

  REFUND_MANAGEMENT_ACCESS = 'CAR_REFUND_MANAGEMENT_ACCESS',
  REFUND_MANAGEMENT_VIEW_DETAIL = 'CAR_REFUND_MANAGEMENT_VIEW_DETAIL',
  REFUND_MANAGEMENT_REJECT = 'CAR_REFUND_MANAGEMENT_REJECT',
  REFUND_MANAGEMENT_APPROVE = 'CAR_REFUND_MANAGEMENT_APPROVE',
  REFUND_MANAGEMENT_VIEW = 'CAR_REFUND_MANAGEMENT_VIEW',
  VOUCHER_MANAGEMENT_ACCESS = 'CAR_VOUCHER_ACCESS',
  VOUCHER_MANAGEMENT_VIEW = 'CAR_VOUCHER_VIEW',
  VOUCHER_MANAGEMENT_ADD = 'CAR_VOUCHER_ADD',
  VOUCHER_MANAGEMENT_TOGGLE_STATUS = 'CAR_VOUCHER_MANAGEMENT_TOGGLE_STATUS',
  VOUCHER_MANAGEMENT_VIEW_DETAIL = 'CAR_VOUCHER_MANAGEMENT_VIEW_DETAIL',
  // VOUCHER_MANAGEMENT_DELETE = 'CAR_VOUCHER_MANAGEMENT_DELETE',
  // REFUND_MANAGEMENT_ACCESS = 'SHOP_REFUND_MANAGEMENT_ACCESS',
  // REFUND_MANAGEMENT_VIEW_DETAIL = 'SHOP_REFUND_MANAGEMENT_VIEW_DETAIL',
  // REFUND_MANAGEMENT_REJECT = 'SHOP_REFUND_MANAGEMENT_REJECT',
  // REFUND_MANAGEMENT_APPROVE = 'SHOP_REFUND_MANAGEMENT_APPROVE',
  // REFUND_MANAGEMENT_RESUBMIT_REFUND = 'SHOP_REFUND_MANAGEMENT_RESUBMIT_REFUND',
  // REFUND_MANAGEMENT_VIEW = 'SHOP_REFUND_MANAGEMENT_VIEW_DETAIL',
  // VOUCHER_MANAGEMENT_ACCESS = 'SYSTEM_VOUCHER_ACCESS',
  // VOUCHER_MANAGEMENT_VIEW = 'SYSTEM_VOUCHER_VIEW_DETAIL',
  // VOUCHER_MANAGEMENT_ADD = 'SYSTEM_VOUCHERT_ADD',
  // VOUCHER_MANAGEMENT_TOGGLE_STATUS = 'SYSTEM_VOUCHER_TOGGLE_STATUS',
  // VOUCHER_MANAGEMENT_VIEW_DETAIL = 'SYSTEM_VOUCHER_VIEW_DETAIL',
  AUTOMAKER_MANAGEMENT_ACCESS = 'CAR_AUTOMAKER_MANAGEMENT_ACCESS',
  AUTOMAKER_MANAGEMENT_VIEW = 'CAR_AUTOMAKER_MANAGEMENT_VIEW',
  AUTOMAKER_MANAGEMENT_ADD = 'CAR_AUTOMAKER_MANAGEMENT_ADD',
  AUTOMAKER_MANAGEMENT_EDIT = 'CAR_AUTOMAKER_MANAGEMENT_EDIT',
  AUTOMAKER_MANAGEMENT_DELETE = 'CAR_AUTOMAKER_MANAGEMENT_DELETE',
  AUTOMAKER_MANAGEMENT_APPROVE = 'CAR_AUTOMAKER_MANAGEMENT_APPROVE',
  AUTOMAKER_MANAGEMENT_REJECT = 'CAR_AUTOMAKER_MANAGEMENT_REJECT',
  AMENITY_MANAGEMENT_ACCESS = 'CAR_AMENITY_MANAGEMENT_ACCESS',
  AMENITY_MANAGEMENT_VIEW = 'CAR_AMENITY_MANAGEMENT_VIEW',
  AMENITY_MANAGEMENT_ADD = 'CAR_AMENITY_MANAGEMENT_ADD',
  AMENITY_MANAGEMENT_EDIT = 'CAR_AMENITY_MANAGEMENT_EDIT',
  AMENITY_MANAGEMENT_DELETE = 'CAR_AMENITY_MANAGEMENT_DELETE',
  AMENITY_MANAGEMENT_APPROVE = 'CAR_AMENITY_MANAGEMENT_APPROVE',
  AMENITY_MANAGEMENT_REJECT = 'CAR_AMENITY_MANAGEMENT_REJECT',
  BANNER_ACCESS = 'BANNER_CAR_ACCESS',
  BANNER_VIEW = 'BANNER_CAR_VIEW',
  BANNER_ADD = 'BANNER_CAR_ADD',
  BANNER_EDIT = 'BANNER_CAR_EDIT',
  BANNER_DELETE = 'BANNER_CAR_DELETE',
  BANNER_STATUS = 'BANNER_CAR_STATUS',
  CHAT_FAQ_ACCESS = 'CHAT_FAQ_ACCESS',
  CHAT_FAQ_VIEW = 'CHAT_FAQ_VIEW',
  CHAT_FAQ_ADD = 'CHAT_FAQ_ADD',
  CHAT_FAQ_EDIT = 'CHAT_FAQ_EDIT',
  CHAT_FAQ_DELETE = 'CHAT_FAQ_DELETE',
  CHAT_SUPPORT_ACCESS = 'CHAT_SUPPORT_ACCESS',
  CHAT_SUPPORT_VIEW_CHAT = 'CHAT_SUPPORT_VIEW_CHAT',
  CHAT_SUPPORT_VIEW_HISTORY = 'CHAT_SUPPORT_VIEW_HISTORY',
  CHAT_SUPPORT_DELETE_HISTORY = 'CHAT_SUPPORT_DELETE_HISTORY',
  CHAT_SUPPORT_BASIC_CHAT_ACTION = 'CHAT_SUPPORT_BASIC_CHAT_ACTION',
  CHAT_SUPPORT_SETTING_VIEW = 'CHAT_SUPPORT_SETTING_VIEW',
  CHAT_SUPPORT_SETTING_EDIT = 'CHAT_SUPPORT_SETTING_EDIT',
  LANDING_PAGE_ACCESS = 'CAR_LANDING_PAGE_ACCESS',
  LANDING_PAGE_VIEW = 'CAR_LANDING_PAGE_VIEW',
  LANDING_PAGE_ADD = 'CAR_LANDING_PAGE_ADD',
  LANDING_PAGE_EDIT = 'CAR_LANDING_PAGE_EDIT',
  LANDING_PAGE_TOGGLE_STATUS = 'CAR_LANDING_PAGE_TOGGLE_STATUS',
  LANDING_PAGE_DELETE = 'CAR_LANDING_PAGE_DELETE',
  RENTAL_PURPOSE_ACCESS = 'CAR_RENTAL_PURPOSE_ACCESS',
  RENTAL_PURPOSE_VIEW = 'CAR_RENTAL_PURPOSE_VIEW',
  RENTAL_PURPOSE_TOGGLE_STATUS = 'CAR_RENTAL_PURPOSE_TOGGLE_STATUS',
  RENTAL_PURPOSE_ADD = 'CAR_RENTAL_PURPOSE_ADD',
  RENTAL_PURPOSE_EDIT = 'CAR_RENTAL_PURPOSE_EDIT',
  RENTAL_PURPOSE_DELETE = 'CAR_RENTAL_PURPOSE_DELETE',
  PUBLIC_HOLIDAY_ACCESS = 'CAR_PUBLIC_HOLIDAY_ACCESS',
  PUBLIC_HOLIDAY_VIEW = 'CAR_PUBLIC_HOLIDAY_VIEW',
  PUBLIC_HOLIDAY_TOGGLE_STATUS = 'CAR_PUBLIC_HOLIDAY_TOGGLE_STATUS',
  PUBLIC_HOLIDAY_ADD = 'CAR_PUBLIC_HOLIDAY_ADD',
  PUBLIC_HOLIDAY_EDIT = 'CAR_PUBLIC_HOLIDAY_EDIT',
  PUBLIC_HOLIDAY_DELETE = 'CAR_PUBLIC_HOLIDAY_DELETE',
  SEAT_CAPACITY_ACCESS = 'CAR_SEAT_CAPACITY_ACCESS',
  SEAT_CAPACITY_VIEW = 'CAR_SEAT_CAPACITY_VIEW',
  SEAT_CAPACITY_TOGGLE_STATUS = 'CAR_SEAT_CAPACITY_TOGGLE_STATUS',
  SEAT_CAPACITY_ADD = 'CAR_SEAT_CAPACITY_ADD',
  SEAT_CAPACITY_EDIT = 'CAR_SEAT_CAPACITY_EDIT',
  SEAT_CAPACITY_DELETE = 'CAR_SEAT_CAPACITY_DELETE',
  RSS_ACCESS = 'CAR_RSS_FEED_ACCESS',
  RSS_EDIT = 'CAR_RSS_FEED_EDIT',
  RSS_GET_DATA = 'CAR_RSS_FEED_GET_DATA',
  REVIEW_MANAGEMENT_ACCESS = 'CAR_REVIEW_MANAGEMENT_ACCESS',
  REVIEW_MANAGEMENT_VIEW = 'CAR_REVIEW_MANAGEMENT_VIEW',
  REVIEW_MANAGEMENT_EDIT = 'CAR_REVIEW_MANAGEMENT_EDIT',
  REVIEW_MANAGEMENT_HIDE = 'CAR_REVIEW_MANAGEMENT_HIDE',
  REVIEW_MANAGEMENT_EXPORT = 'CAR_REVIEW_MANAGEMENT_EXPORT',
}
